import React from 'react'
import img from '../../../../public/static/image-background/logo-v-02.png'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

// ===== MAU15: Emerald Forest — deep green + amber gold, 2-column =====
const Mau15 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const c = {
        bg1: '#0b2417',
        bg2: '#14472c',
        bg3: '#0f3020',
        amber: '#e8a020',
        amberLight: '#f5c842',
        amberDark: '#a06b0e',
        text: '#ffffff',
        textMuted: 'rgba(255,255,255,0.55)',
        card: 'rgba(15,48,32,0.85)',
        cardBorder: 'rgba(232,160,32,0.35)',
        divider: 'rgba(232,160,32,0.25)'
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} style={{
            width, minHeight: width / 1.3,
            fontFamily: 'SFUHelveticaCondensedBold',
            background: `radial-gradient(ellipse at top left, ${c.bg2} 0%, ${c.bg1} 60%, ${c.bg3} 100%)`,
            position: 'relative', overflow: 'hidden', padding: `${px * 2.5}px`
        }}>
            {/* Leaf-vein subtle background lines */}
            {[...Array(5)].map((_, i) => (
                <div key={i} style={{
                    position: 'absolute', top: `${i * 22}%`, left: 0, right: 0,
                    height: '1px', background: `rgba(232,160,32,${0.04 + i * 0.01})`, zIndex: 0
                }} />
            ))}
            {/* Gold corner ornaments */}
            <div style={{ position: 'absolute', top: `${px * 1}px`, left: `${px * 1}px`, width: `${px * 5}px`, height: `${px * 5}px`, borderTop: `${px * 0.35}px solid ${c.amber}`, borderLeft: `${px * 0.35}px solid ${c.amber}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', top: `${px * 1}px`, right: `${px * 1}px`, width: `${px * 5}px`, height: `${px * 5}px`, borderTop: `${px * 0.35}px solid ${c.amber}`, borderRight: `${px * 0.35}px solid ${c.amber}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', bottom: `${px * 1}px`, left: `${px * 1}px`, width: `${px * 5}px`, height: `${px * 5}px`, borderBottom: `${px * 0.35}px solid ${c.amber}`, borderLeft: `${px * 0.35}px solid ${c.amber}`, zIndex: 0 }} />
            <div style={{ position: 'absolute', bottom: `${px * 1}px`, right: `${px * 1}px`, width: `${px * 5}px`, height: `${px * 5}px`, borderBottom: `${px * 0.35}px solid ${c.amber}`, borderRight: `${px * 0.35}px solid ${c.amber}`, zIndex: 0 }} />

            <div style={{ position: 'relative', zIndex: 1 }}>
                {/* HEADER */}
                <div style={{
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    marginBottom: `${px * 2.5}px`,
                    borderBottom: `${px * 0.3}px solid ${c.amber}`,
                    paddingBottom: `${px * 2}px`
                }}>
                    <Image src={dataSeason?.logo} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                    <div style={{ flex: 1, textAlign: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: `${px * 1.5}px`, marginBottom: `${px * 0.5}px` }}>
                            <div style={{ height: `${px * 0.2}px`, flex: 1, background: `linear-gradient(to right, transparent, ${c.amber})` }} />
                            <h1 style={{ color: c.amber, fontSize: `${px * 4.8}px`, textTransform: 'uppercase', margin: 0, letterSpacing: `${px * 0.3}px`, textShadow: `0 2px 12px rgba(232,160,32,0.5)` }}>
                                {t(titleTemplate(dataSchedules[0]?.dataGo))}
                            </h1>
                            <div style={{ height: `${px * 0.2}px`, flex: 1, background: `linear-gradient(to left, transparent, ${c.amber})` }} />
                        </div>
                        <h2 style={{ color: c.text, fontSize: `${px * 2.2}px`, textTransform: 'uppercase', margin: 0, opacity: 0.85 }}>{dataSeason?.name}</h2>
                        {t(numberRound) === numberRound && (
                            <div style={{ display: 'inline-block', background: `linear-gradient(90deg,${c.amberDark},${c.amber},${c.amberDark})`, color: '#000', padding: `${px * 0.35}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t('round')} {numberRound}</div>
                        )}
                        {t(numberRound) && t(numberRound) !== numberRound && (
                            <div style={{ display: 'inline-block', background: `linear-gradient(90deg,${c.amberDark},${c.amber},${c.amberDark})`, color: '#000', padding: `${px * 0.35}px ${px * 2.5}px`, borderRadius: `${px * 0.4}px`, fontSize: `${px * 1.9}px`, fontWeight: 'bold', marginTop: `${px * 0.6}px` }}>{t(numberRound)}</div>
                        )}
                    </div>
                    <Image src={img} style={{ width: `${px * 10}px`, height: `${px * 10}px`, objectFit: 'contain' }} />
                </div>

                {/* MATCHES — 2 columns */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: `${px * 1.5}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => <Item15 key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} c={c} />)}
                </div>

                {/* SPONSORS */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ marginTop: `${px * 2.5}px`, borderTop: `1px solid ${c.divider}`, paddingTop: `${px * 1.5}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: `${px * 2}px` }}>
                        {sponsorData?.slice(0, 10)?.map((s, idx) => <Image key={idx} src={s.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain' }} />)}
                    </div>
                )}
                <p style={{ textAlign: 'right', color: `rgba(232,160,32,0.5)`, fontSize: `${px * 1.6}px`, marginTop: `${px * 1}px`, letterSpacing: '2px' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORTS.VN'}</p>
            </div>
        </div>
    )
}

const Item15 = React.memo(({ data, px, classCustom, idx, c }) => {
    const { t } = useTranslation()
    const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
    const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']
    let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
    let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''
    let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
    let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name
    let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
    let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

    return (
        <div style={{ width: `calc(50% - ${px * 0.75}px)`, background: c.card, border: `1px solid ${c.cardBorder}`, borderRadius: `${px * 1.2}px`, padding: `${px * 1.8}px ${px * 1.5}px`, display: 'flex', alignItems: 'center', gap: `${px * 1}px`, minHeight: `${px * 11}px`, backdropFilter: 'blur(8px)', boxShadow: `0 2px 16px rgba(0,0,0,0.3)` }}>
            {/* Home */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                <Image src={data?.homeTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid ${c.amber}`, boxShadow: `0 0 10px rgba(232,160,32,0.45)`, backgroundColor: '#fff' }} />
                <Name15 propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} color={c.text} />
            </div>
            {/* Center */}
            <div style={{ flexShrink: 0, minWidth: `${px * 22}px`, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.5}px` }}>
                {data?.isCompleted ? (
                    <>
                        <div style={{ background: `linear-gradient(135deg,${c.amberDark},${c.amber})`, color: '#000', fontWeight: 900, fontSize: `${px * 3.6}px`, padding: `${px * 0.4}px ${px * 1.5}px`, borderRadius: `${px * 3}px`, letterSpacing: '2px', whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 18}px`, boxShadow: `0 4px 12px rgba(232,160,32,0.4)` }}>
                            {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                            {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                            {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                            {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                        </div>
                        {data?.hasPenalty && <span style={{ color: '#fc0366', fontSize: `${px * 1.4}px`, fontWeight: 'bold', whiteSpace: 'nowrap' }}>PK: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore}</span>}
                        <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>{formatDateTime(data?.dateTime, 'dateTime')}</span>
                    </>
                ) : (
                    <>
                        <div style={{ background: `linear-gradient(135deg,${c.amberDark},${c.amber})`, color: '#000', fontWeight: 900, fontSize: `${px * 2.8}px`, padding: `${px * 0.5}px ${px * 2}px`, borderRadius: `${px * 3}px`, whiteSpace: 'nowrap', textAlign: 'center', minWidth: `${px * 16}px` }}>{formatDateTime(data?.dateTime, 'time')}</div>
                        <span style={{ color: c.textMuted, fontSize: `${px * 1.3}px`, textAlign: 'center' }}>{formatDateTime(data?.dateTime, 'date')}</span>
                        {data?.stadium && <span style={{ color: c.textMuted, fontSize: `${px * 1.2}px`, textAlign: 'center', maxWidth: `${px * 14}px`, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{data.stadium}</span>}
                    </>
                )}
            </div>
            {/* Away */}
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: `${px * 0.6}px` }}>
                <Image src={data?.awayTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, borderRadius: '50%', objectFit: 'cover', border: `2px solid rgba(255,255,255,0.3)`, backgroundColor: '#fff' }} />
                <Name15 propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} color={c.text} />
            </div>
        </div>
    )
}, (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data))

const Name15 = React.memo(({ name, px, propClass, color }) => {
    const reSizeBasedOnWidth = () => {
        const el = document.querySelector(`.${propClass}`)
        const container = document.querySelector(`.contain${propClass}`)
        if (!el || !container) return
        const fontSize = window?.getComputedStyle(el)?.fontSize
        el.style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
        if (el.scrollHeight > container.clientHeight) reSizeBasedOnWidth()
    }
    const processInput = () => {
        const el = document.querySelector(`.${propClass}`)
        if (!el) return
        el.innerHTML = name
        el.style.fontSize = px * 2.2 + 'px'
        reSizeBasedOnWidth()
    }
    React.useEffect(() => { processInput() }, [name])
    return (
        <div className={`contain${propClass}`} style={{ width: '100%', height: `${px * 7}px`, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            <h2 className={propClass} style={{ color, textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold', wordBreak: 'break-word', whiteSpace: 'normal', lineHeight: 1.2, fontSize: `${px * 2.2}px` }} />
        </div>
    )
}, (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name))

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => { if (props.src) getBase64(props.src).then(r => setData(r)) }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) &&
        JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) &&
        JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau15, areEqual)
